import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Termenele fără oră sunt stocate la miezul nopții UTC (taskuri vechi / input doar dată).
// Ascundem ora în acest caz; o afișăm doar când a fost setată explicit.
function _isMidnightUTC(d) {
  return d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0;
}

// Formatează un termen (ISO) ca „15 iun" sau „15 iun, 14:30" (ora doar dacă e setată).
export function formatDeadline(iso, { year = false } = {}) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const dateStr = d.toLocaleDateString("ro-RO", year
    ? { day: "2-digit", month: "short", year: "numeric" }
    : { day: "2-digit", month: "short" });
  if (_isMidnightUTC(d)) return dateStr;
  const timeStr = d.toLocaleTimeString("ro-RO", { hour: "2-digit", minute: "2-digit" });
  return `${dateStr}, ${timeStr}`;
}

// Convertește un ISO (UTC) într-un string local „YYYY-MM-DDTHH:mm" pentru <input type="datetime-local">.
export function toDateTimeLocal(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = n => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
